"use client"
import styled from "@emotion/styled"
import { Button, Checkbox } from "@mui/material"
import { useLocale } from "next-intl"
import { useRouter } from "next/navigation"
import { useState } from "react"
import "swiper/css"
import { CheckboxIcon, CheckedCheckboxIcon, Container, Desktop, Mobile, NewText } from "ui"
import { extractProperty } from "utils"

const StyledContainer = styled.div`
  margin-top: 32px;
  background: white;
  ${(props) => props.theme.breakpoints.up("md")} {
    margin-top: 40px;
  }
`
const StyledCheckboxContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: 4px;
`

const StyledCheckbox = styled(Checkbox, {
  shouldForwardProp: (prop) => prop !== "status",
})<{ status: boolean }>`
  padding: 1px 8px 0px 0;
  margin: 0;
  ${(props) =>
    !props.status
      ? `  rect {
    stroke: red;
  }`
      : ""};
`

type Props = {
  data: any
  renderPrompt: boolean
  donationButton: string
}

export const TitleContent: React.FC<Props> = ({ data, renderPrompt, donationButton }) => {
  const title = extractProperty(data, "title")
  const innerText = extractProperty(data, "content")

  const [checked, setChecked] = useState<any>(null)

  const router = useRouter()
  const locale = useLocale()

  const onNavigate = () => {
    if (checked) {
      router.push(locale === "he" ? "/donation-application-form" : "/en/donation-application-form")
    }
  }

  return (
    <Container>
      <StyledContainer>
        <NewText
          desktopFontSize={40}
          desktopFontWeight="400"
          desktopLineHeight="110%"
          mobileFontSize={32}
          mobileFontWeight="400"
          mobileLineHeight={"112.5%"}
          component="h1"
          color={"black"}
        >
          {title}
        </NewText>
        <NewText
          desktopFontSize={18}
          desktopFontWeight="400"
          desktopLineHeight="26px"
          mobileFontSize={16}
          mobileFontWeight="400"
          mobileLineHeight={"23px"}
          component="div"
          color={"black"}
          dangerouslySetInnerHTML={{ __html: innerText }}
          maxWidth="800px"
          style={{ marginBlockStart: 16 }}
        />
        {renderPrompt && (
          <StyledCheckboxContainer>
            <StyledCheckbox
              icon={<CheckboxIcon />}
              checkedIcon={<CheckedCheckboxIcon />}
              sx={{
                ":hover": {
                  backgroundColor: "transparent",
                },
                padding: 0,
                bottom: "4px",
                marginInlineStart: "8px",
                "& .MuiSvgIcon-root": { fontSize: 32 },
                "& .Mui-focusVisible": {
                  outline: "1px auto rgba(19,124,189,.6)",
                  outlineOffset: 2,
                },
              }}
              status={!checked}
              value={checked}
              onChange={() => setChecked(!checked)}
            />
            <div>
              <NewText
                desktopFontSize={18}
                desktopFontWeight="400"
                desktopLineHeight="26px"
                mobileFontSize={16}
                mobileFontWeight="400"
                mobileLineHeight={"23px"}
                component="h1"
                color={"black"}
                maxWidth={"700px"}
              >
                {locale === "he" ? " קראתי את מדיניות התרומות" : "I have read the donation policy"}
              </NewText>
            </div>
          </StyledCheckboxContainer>
        )}
        {renderPrompt && (
          <>
            <Desktop>
              <Button
                sx={{
                  textDecoration: "none",
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "fit-content",
                  height: "fit-content",

                  marginTop: "32px",
                  marginLeft: "auto",
                  fontSize: "18px",
                }}
                variant="outlined"
                size="large"
                disabled={!checked}
                onClick={onNavigate}
              >
                {donationButton}{" "}
              </Button>
            </Desktop>
            <Mobile>
              <Button
                sx={{
                  textDecoration: "none",
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "fit-content",
                  height: "fit-content",

                  marginTop: "32px",
                  marginLeft: "auto",
                  fontSize: "16px",
                }}
                variant="outlined"
                size="small"
                disabled={!checked}
                onClick={onNavigate}
              >
                {donationButton}
              </Button>
            </Mobile>
          </>
        )}
      </StyledContainer>
    </Container>
  )
}
export default TitleContent
